var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAskTigerSparkle = function SvgAskTigerSparkle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.411 458.835C248.697 389.183 289.916 249.879 460.512 249.879",
    stroke: "#42A6C7",
    strokeWidth: 64.3413,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248.799 458.835C249.513 389.183 208.294 249.879 37.6977 249.879",
    stroke: "#3D7CC9",
    strokeWidth: 64.3413,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.799 40.9227C249.513 110.575 208.294 249.879 37.6977 249.879",
    stroke: "#EA0029",
    strokeWidth: 64.3413,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.411 40.9227C248.697 110.575 289.916 249.879 460.512 249.879",
    stroke: "#6CCAB8",
    strokeWidth: 64.3413,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.102 333.984C273.311 378.102 281.311 425.459 280.965 459.167C280.785 476.656 266.683 490.742 249.296 491.004H248.909C231.522 490.742 217.421 476.656 217.241 459.167C216.895 425.459 224.894 378.102 249.102 333.984Z",
    fill: "#18618E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.107 165.945C224.897 121.827 216.898 74.4701 217.244 40.7617C217.424 23.2731 231.525 9.1871 248.912 8.9248L249.301 8.9248C266.688 9.18723 280.789 23.2732 280.969 40.7617C281.315 74.4701 273.315 121.827 249.107 165.945Z",
    fill: "#783036"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3896 282.559C92.535 282.219 134.804 269.985 168.489 250.396C134.324 230.527 91.3295 218.225 38.1562 218.225C20.3892 218.225 5.98633 232.628 5.98633 250.396C5.98641 268.163 20.3893 282.566 38.1562 282.566L40.3896 282.559Z",
    fill: "#553137"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M460.973 282.566C478.74 282.566 493.142 268.163 493.143 250.396C493.143 232.628 478.74 218.225 460.973 218.225C407.799 218.225 364.805 230.527 330.64 250.396C364.805 270.264 407.8 282.566 460.973 282.566Z",
    fill: "#00918A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAskTigerSparkle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ask-tiger-sparkle.f6ad9a885a2e48a56e68567ba80cf6d4.svg";